const roleIds = Object.freeze({
    especialist: "c0d81e19-8eb9-428c-9e56-66479bf5b34b",
    especialist_RP: "2843db69-3643-4151-b62d-96405c105d91",
});

export default roleIds;